import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HERO_PHOTO_FILTER } from '../utils/photoFilters';
type StartHeroImageProps = {
  mainImage: string;
  mainAlt: string;
  portraitImage: string;
  portraitAlt: string;
  toggleLabel: string;
};
const SWAP = {
  duration: 0.2,
  ease: 'easeOut' as const
};

/**
 * Hero photo for /start: main photo with a small portrait overlay.
 * Hovering (desktop) or tapping (touch) swaps to the large portrait,
 * matching the image swap on the homepage hero.
 */
export function StartHeroImage({
  mainImage,
  mainAlt,
  portraitImage,
  portraitAlt,
  toggleLabel
}: StartHeroImageProps) {
  const [showPortrait, setShowPortrait] = useState(false);
  const [canHover, setCanHover] = useState(false);
  useEffect(() => {
    const query = window.matchMedia('(hover: hover) and (pointer: fine)');
    setCanHover(query.matches);
    const onChange = (event: MediaQueryListEvent) => setCanHover(event.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return <button type="button" aria-pressed={showPortrait} aria-label={toggleLabel} onMouseEnter={() => canHover && setShowPortrait(true)} onMouseLeave={() => canHover && setShowPortrait(false)} onFocus={() => canHover && setShowPortrait(true)} onBlur={() => setShowPortrait(false)} onClick={() => !canHover && setShowPortrait(open => !open)} className="relative block w-full pb-6 text-left cursor-pointer rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-4 focus-visible:ring-offset-navy" data-id="element-201" data-mp="2ore1i1w140yn">
      <div className="relative w-full aspect-[4/3]" data-id="element-202" data-mp="1w40ccpyko9p3">
        <AnimatePresence initial={false} data-id="element-203" data-mp="1w5bg4ps0phg7">
          {showPortrait ? <motion.img key="portrait" src={portraitImage} alt={portraitAlt} initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.98
        }} transition={SWAP} style={{
          filter: HERO_PHOTO_FILTER,
          objectPosition: '50% 20%'
        }} className="absolute inset-0 w-full h-full rounded-2xl shadow-2xl object-cover border border-gold-400/20" data-id="element-204" data-mp="3vfb7nafxi8mi" /> : <motion.div key="main" initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.98
        }} transition={SWAP} className="absolute inset-0" data-id="element-205" data-mp="27ibs84wqtbl6">
              <img src={mainImage} alt={mainAlt} style={{
            filter: HERO_PHOTO_FILTER
          }} className="w-full h-full rounded-2xl shadow-2xl object-cover border border-gold-400/20" data-id="element-206" data-mp="1xmi6pw11q7r9" />
              <div style={{
            borderColor: '#D4A24C'
          }} className="absolute -bottom-6 -left-3 md:-left-8 w-[30%] aspect-[4/5] rounded-xl border-2 overflow-hidden shadow-[0_12px_32px_rgba(0,0,0,0.45)]" data-id="element-207" data-mp="r54qv7mpd54z">
                <img src={portraitImage} alt="" aria-hidden="true" style={{
              width: '256%',
              left: '-80%',
              top: '-5.3%',
              filter: HERO_PHOTO_FILTER
            }} className="absolute max-w-none" data-id="element-208" data-mp="30f44z5i3x1rq" />
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </button>;
}